import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { Container } from '../components/Container'
import Header from '../components/Header'
import * as yup from 'yup'
import {
    formatuseFormErrors,
    getErrorMessage,
    isValidCustomer,
    log,
} from '../helpers/utils'
import ErrorAlert from '../components/Alerts/ErrorAlert'
import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
import SuccessAlert from '../components/Alerts/SuccessAlert'
import Loader from '../components/Loader'
// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { CustomerAPI, CustomerFetcher } from '../apis/CustomerAPI'
import useSWR, { useSWRConfig } from 'swr'
import { omit } from 'lodash'
import { saveAndLoginUser } from '../helpers/checkout'
import { SIGNUP_PATH } from '../helpers/signupTracking'
import ReCAPTCHA from 'react-google-recaptcha'
import { GeneralAPI } from '../apis/GeneralAPI'
import { shouldSkipLoginRecaptcha } from '../helpers/shouldSkipLoginRecaptcha'
import Link from 'next/link'
import { EyeIcon, EyeOffIcon, MailIcon } from '@heroicons/react/outline'
import { ChevronDownIcon } from '@heroicons/react/solid'
// import withoutAuthentication from '../hoc/withoutAuthentication'

const HUBSPOT_INDUSTRY_FIELD = 'what_industry_are_you_part_of_'

const accountFields = [
    { name: 'email', label: 'Email', type: 'email', required: true },
    {
        name: 'phone',
        label: 'Phone Number',
        type: 'tel',
        required: true,
    },
    { name: 'first_name', label: 'First Name', type: 'text', required: true },
    { name: 'last_name', label: 'Last Name', type: 'text', required: true },
    {
        name: 'budget',
        label: 'What is your monthly marketing budget?',
        type: 'select',
        required: true,
    },
    {
        name: HUBSPOT_INDUSTRY_FIELD,
        label: 'What industry are you in?',
        type: 'select',
        required: false,
    },
    { name: 'password', label: 'Password', type: 'password', required: true },
    {
        name: 'confirm_password',
        label: 'Confirm Password',
        type: 'password',
        required: true,
    },
    {
        name: 'tos',
        label: 'I agree to all Terms & Conditions',
        type: 'checkbox',
        required: true,
    },
]

const rules = () => {
    let rulesObject = {}
    accountFields.forEach(({ name, label, type, required }) => {
        if (type == 'checkbox') {
            rulesObject[name] = required
                ? yup
                      .bool()
                      .oneOf([true], 'Please accept the terms and conditions.')
                : yup.bool()
            return
        }

        if (name === 'confirm_password') {
            let confirmPasswordRule = yup
                .string()
                .oneOf(
                    [yup.ref('password'), null],
                    'Password and Confirm Password do not match.',
                )

            rulesObject[name] = required
                ? confirmPasswordRule.required(`${label} is required.`)
                : confirmPasswordRule
            return
        }

        if (type == 'tel') {
            let phoneRule = yup
                .string()
                .matches(
                    /^(\+\d{1,3}[- ]?)?\d{10}$/,
                    'Phone number is not valid',
                )

            rulesObject[name] = required
                ? phoneRule.required('Phone number is required')
                : phoneRule
            return
        }

        let stringRule = yup.string()
        rulesObject[name] = required
            ? stringRule.required(`${label} is required.`)
            : stringRule
    })
    return yup.object().shape(rulesObject)
}

export function ResetPassword({ data }) {
    const router = useRouter()
    const skipCaptcha = shouldSkipLoginRecaptcha()
    const [success, setSuccess] = useState(null)

    const { data: customer } = useSWR(CustomerAPI.getCustomer, CustomerFetcher)
    const { mutate } = useSWRConfig()

    const [loading, setLoading] = useState(false)
    const [captchaToken, setCaptchaToken] = useState(null)
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    // const { executeRecaptcha } = useGoogleReCaptcha()

    const recaptchaRef = useRef()
    const onCaptchaChange = (value) => {
        setCaptchaToken(value || null)
        if (recaptchaRef.current) {
            recaptchaRef.current.value = value
        }
    }

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors },
        getValues,
        watch,
    } = useForm({ resolver: yupResolver(rules()) })
    const hasAcceptedTerms = watch('tos', false)

    const attemptCreateAccount = async (data) => {
        try {
            setLoading(true)
            if (!skipCaptcha && !captchaToken) {
                throw Error('Please complete the reCAPTCHA.')
            }
            const gReCaptchaToken = skipCaptcha ? '' : captchaToken

            // throw error id password and confirm password do not match
            if (data.password !== data.confirm_password) {
                throw Error('Password and Confirm Password do not match.')
            }

            data.captcha = gReCaptchaToken
            data = omit(data, [
                'tos',
                'phone',
                'confirm_password',
                'budget',
                HUBSPOT_INDUSTRY_FIELD,
            ])
            data.billing = {
                first_name: getValues('first_name'),
                last_name: getValues('last_name'),
                email: getValues('email'),
                phone: getValues('phone'),
            }

            await saveAndLoginUser(data, SIGNUP_PATH.STANDALONE)

            setSuccess('Account created successfully. Logging you in...')
            await mutate(CustomerAPI.getCustomer)
        } catch (e) {
            const message = getErrorMessage(e)
            log(message)
            setError('custom', { type: 'custom', message })
        } finally {
            setLoading(false)
        }
    }

    // const handleForm = async (e) => {
    //     e.preventDefault()
    //     try {
    //         setLoading(true)
    //         await handleSubmit(attemptCreateAccount)()
    //         setSuccess('Account created successfully. Logging you in...')
    //     } finally {
    //         setLoading(false)
    //     }
    // }

    useEffect(() => {
        if (isValidCustomer(customer)) router.push('/my-account')
    }, [customer, router])

    log('errors', errors)

    return (
        <div>
            {loading && <Loader text="Working..." />}
            <Header meta={data?.yoast_head} />
            <div className="bg-[#fafafa]">
                <Container>
                    <div className="px-6 py-16">
                        <div className="mx-auto max-w-[520px]">
                            {success ? (
                                <SuccessAlert success={success} />
                            ) : (
                                <div className="rounded-2xl border border-gray-100 bg-white p-10 shadow-[0_8px_40px_-12px_rgba(15,17,21,0.08)]">
                                    <div className="mb-8 text-center">
                                        <div
                                            className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl"
                                            style={{
                                                background:
                                                    'linear-gradient(135deg, #ef6c2a 0%, #f59e3b 100%)',
                                            }}>
                                            <MailIcon className="h-6 w-6 text-white" />
                                        </div>
                                        <h1 className="text-[26px] font-bold tracking-tight text-[#0f1115]">
                                            Create your account
                                        </h1>
                                        <p className="mt-2 text-[14px] text-gray-500">
                                            Start sending campaigns in minutes.
                                        </p>
                                    </div>

                                    <form
                                        data-hs-cf-disabled="true"
                                        className="hs-form-exclude space-y-4"
                                        onSubmit={handleSubmit(
                                            attemptCreateAccount,
                                        )}>
                                        <div>
                                            <label
                                                htmlFor="email"
                                                className="mb-1.5 block text-[13px] font-medium text-gray-700">
                                                Email
                                            </label>
                                            <input
                                                id="email"
                                                type="email"
                                                placeholder="you@company.com"
                                                autoComplete="email"
                                                {...register('email')}
                                                className="h-11 w-full rounded-xl border border-gray-200 bg-gray-50 px-3.5 text-[14px] text-[#0f1115] placeholder:text-gray-400 transition-all focus:border-[#ef6c2a] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#ef6c2a]/10"
                                            />
                                        </div>

                                        <div>
                                            <label
                                                htmlFor="phone"
                                                className="mb-1.5 block text-[13px] font-medium text-gray-700">
                                                Phone Number
                                            </label>
                                            <input
                                                id="phone"
                                                type="tel"
                                                placeholder="(555) 123-4567"
                                                autoComplete="tel"
                                                {...register('phone')}
                                                className="h-11 w-full rounded-xl border border-gray-200 bg-gray-50 px-3.5 text-[14px] text-[#0f1115] placeholder:text-gray-400 transition-all focus:border-[#ef6c2a] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#ef6c2a]/10"
                                            />
                                        </div>

                                        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                            <div>
                                                <label
                                                    htmlFor="first_name"
                                                    className="mb-1.5 block text-[13px] font-medium text-gray-700">
                                                    First Name
                                                </label>
                                                <input
                                                    id="first_name"
                                                    type="text"
                                                    placeholder="Jane"
                                                    autoComplete="given-name"
                                                    {...register('first_name')}
                                                    className="h-11 w-full rounded-xl border border-gray-200 bg-gray-50 px-3.5 text-[14px] text-[#0f1115] placeholder:text-gray-400 transition-all focus:border-[#ef6c2a] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#ef6c2a]/10"
                                                />
                                            </div>
                                            <div>
                                                <label
                                                    htmlFor="last_name"
                                                    className="mb-1.5 block text-[13px] font-medium text-gray-700">
                                                    Last Name
                                                </label>
                                                <input
                                                    id="last_name"
                                                    type="text"
                                                    placeholder="Doe"
                                                    autoComplete="family-name"
                                                    {...register('last_name')}
                                                    className="h-11 w-full rounded-xl border border-gray-200 bg-gray-50 px-3.5 text-[14px] text-[#0f1115] placeholder:text-gray-400 transition-all focus:border-[#ef6c2a] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#ef6c2a]/10"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label
                                                htmlFor="budget"
                                                className="mb-1.5 block text-[13px] font-medium text-gray-700">
                                                What is your monthly marketing
                                                budget?
                                            </label>
                                            <div className="relative">
                                                <select
                                                    id="budget"
                                                    defaultValue=""
                                                    {...register('budget')}
                                                    className="h-11 w-full cursor-pointer appearance-none rounded-xl border border-gray-200 bg-gray-50 px-3.5 text-[14px] text-[#0f1115] transition-all focus:border-[#ef6c2a] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#ef6c2a]/10">
                                                    <option value="" disabled>
                                                        Select your budget
                                                    </option>
                                                    <option value="<1000">
                                                        Less than $1,000
                                                    </option>
                                                    <option value="1000-5000">
                                                        $1,000-$5,000
                                                    </option>
                                                    <option value="5000-10000">
                                                        $5,000-$10,000
                                                    </option>
                                                    <option value="10000-20000">
                                                        $10,000-$20,000
                                                    </option>
                                                    <option value="20000-50000">
                                                        $20,000-$50,000
                                                    </option>
                                                    <option value="50000-75000">
                                                        $50,000-$75,000
                                                    </option>
                                                    <option value="75000-150000">
                                                        $75,000-$150,000
                                                    </option>
                                                    <option value="150000+">
                                                        $150,000+
                                                    </option>
                                                </select>
                                                <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                                            </div>
                                        </div>

                                        <div>
                                            <label
                                                htmlFor="industry"
                                                className="mb-1.5 block text-[13px] font-medium text-gray-700">
                                                What industry are you in?
                                            </label>
                                            <div className="relative">
                                                <select
                                                    id="industry"
                                                    defaultValue=""
                                                    {...register(
                                                        HUBSPOT_INDUSTRY_FIELD,
                                                    )}
                                                    className="h-11 w-full cursor-pointer appearance-none rounded-xl border border-gray-200 bg-gray-50 px-3.5 text-[14px] text-[#0f1115] transition-all focus:border-[#ef6c2a] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#ef6c2a]/10">
                                                    <option value="" disabled>
                                                        Select your industry
                                                    </option>
                                                    <option value="Real Estate">
                                                        Real Estate
                                                    </option>
                                                    <option value="Roofing">
                                                        Roofing
                                                    </option>
                                                    <option value="HVAC/Plumbing">
                                                        HVAC/Plumbing
                                                    </option>
                                                    <option value="Solar">
                                                        Solar
                                                    </option>
                                                    <option value="Landscaping">
                                                        Landscaping
                                                    </option>
                                                    <option value="Insurance">
                                                        Insurance
                                                    </option>
                                                    <option value="Other">
                                                        Other
                                                    </option>
                                                </select>
                                                <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                                            </div>
                                        </div>

                                        <div>
                                            <label
                                                htmlFor="password"
                                                className="mb-1.5 block text-[13px] font-medium text-gray-700">
                                                Password
                                            </label>
                                            <div className="relative">
                                                <input
                                                    id="password"
                                                    type={
                                                        showPassword
                                                            ? 'text'
                                                            : 'password'
                                                    }
                                                    placeholder="At least 8 characters"
                                                    autoComplete="new-password"
                                                    {...register('password')}
                                                    className="h-11 w-full rounded-xl border border-gray-200 bg-gray-50 px-3.5 pr-11 text-[14px] text-[#0f1115] placeholder:text-gray-400 transition-all focus:border-[#ef6c2a] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#ef6c2a]/10"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setShowPassword(
                                                            (value) => !value,
                                                        )
                                                    }
                                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                                    aria-label={
                                                        showPassword
                                                            ? 'Hide password'
                                                            : 'Show password'
                                                    }>
                                                    {showPassword ? (
                                                        <EyeOffIcon className="h-4 w-4" />
                                                    ) : (
                                                        <EyeIcon className="h-4 w-4" />
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        <div>
                                            <label
                                                htmlFor="confirm_password"
                                                className="mb-1.5 block text-[13px] font-medium text-gray-700">
                                                Confirm Password
                                            </label>
                                            <div className="relative">
                                                <input
                                                    id="confirm_password"
                                                    type={
                                                        showConfirmPassword
                                                            ? 'text'
                                                            : 'password'
                                                    }
                                                    placeholder="Re-enter password"
                                                    autoComplete="new-password"
                                                    {...register(
                                                        'confirm_password',
                                                    )}
                                                    className="h-11 w-full rounded-xl border border-gray-200 bg-gray-50 px-3.5 pr-11 text-[14px] text-[#0f1115] placeholder:text-gray-400 transition-all focus:border-[#ef6c2a] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#ef6c2a]/10"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setShowConfirmPassword(
                                                            (value) => !value,
                                                        )
                                                    }
                                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                                    aria-label={
                                                        showConfirmPassword
                                                            ? 'Hide confirm password'
                                                            : 'Show confirm password'
                                                    }>
                                                    {showConfirmPassword ? (
                                                        <EyeOffIcon className="h-4 w-4" />
                                                    ) : (
                                                        <EyeIcon className="h-4 w-4" />
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        <label className="flex cursor-pointer items-start gap-3 pt-2 select-none">
                                            <input
                                                type="checkbox"
                                                {...register('tos')}
                                                className="sr-only"
                                            />
                                            <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-md border border-gray-300 bg-white transition-colors hover:border-gray-400">
                                                {hasAcceptedTerms ? (
                                                    <span className="h-2.5 w-2.5 rounded-sm bg-[#ef6c2a]" />
                                                ) : null}
                                            </span>
                                            <span className="text-[14px] leading-5 text-gray-600">
                                                I agree to the{' '}
                                                <a
                                                    href="/terms"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="font-medium text-[#ef6c2a] hover:underline">
                                                    Terms &amp; Conditions
                                                </a>{' '}
                                                and{' '}
                                                <a
                                                    href="https://openlettermarketing.com/privacy-policy/"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="font-medium text-[#ef6c2a] hover:underline">
                                                    Privacy Policy
                                                </a>
                                                .
                                            </span>
                                        </label>

                                        {!skipCaptcha && (
                                            <div className="rounded-xl border border-gray-200 bg-gray-50 px-3.5 py-3">
                                                <ReCAPTCHA
                                                    ref={recaptchaRef}
                                                    sitekey={
                                                        process.env
                                                            .NEXT_PUBLIC_RECAPTCHA2_SITE_KEY
                                                    }
                                                    onChange={onCaptchaChange}
                                                    onExpired={() =>
                                                        onCaptchaChange(null)
                                                    }
                                                    size="normal"
                                                    theme="light"
                                                />
                                            </div>
                                        )}

                                        {Object.values(errors).length > 0 && (
                                            <ErrorAlert
                                                error={formatuseFormErrors(
                                                    errors,
                                                )}
                                                heading="Please fix following error(s)."
                                            />
                                        )}

                                        <button
                                            type="submit"
                                            disabled={
                                                (!skipCaptcha &&
                                                    !captchaToken) ||
                                                loading
                                            }
                                            className={`w-full rounded-xl py-3.5 text-[15px] font-semibold transition-all shadow-sm ${
                                                (!skipCaptcha &&
                                                    !captchaToken) ||
                                                loading
                                                    ? 'cursor-not-allowed bg-gray-200 text-gray-400'
                                                    : 'bg-[#ef6c2a] text-white hover:-translate-y-0.5 hover:shadow-md'
                                            }`}>
                                            Create Account
                                        </button>

                                        <p className="pt-1 text-center text-[14px] text-gray-500">
                                            Already have an account?{' '}
                                            <Link href="/login">
                                                <a className="font-semibold text-[#ef6c2a] hover:underline">
                                                    Sign in
                                                </a>
                                            </Link>
                                        </p>
                                    </form>
                                </div>
                            )}
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default ResetPassword

//
export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/create-account')
    const data = page ? page[0] : {}
    return {
        props: { data },
        revalidate: 10, // In seconds
    }
}
